import { USER_ROLES } from "@/mappings/user-roles";

export default [
    {
        path: 'pair/:id',
        name: 'broker-pair',
        component: (): Promise<any> => import('@/views/broker/BrokerPair.vue'),
        meta: {
            title: '',
            requiresAuth: true,
            roles: [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR],
        },
    },
];
